import React from 'react';
import { motion } from 'framer-motion';
const fade = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function HeroSection() {
  return <section className="relative w-full h-screen overflow-hidden bg-primary" data-id="element-90">
      {/* Full-bleed render — the image leads */}
      <motion.div initial={{
      opacity: 0,
      scale: 1.08
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1]
    }} className="absolute inset-0" data-id="element-91">
        <img src="https://cdn.magicpatterns.com/uploads/cKEiYJacx2YS7Gu3QzKmHZ/1.png" alt="Exterior render of 35 Campanilla, a modern residence in Ayala Westgrove Heights" className="w-full h-full object-cover" data-id="element-92" />
      </motion.div>

      {/* Soft scrim only where text sits, so the image stays dominant */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-black/20 pointer-events-none" data-id="element-93" />

      {/* Quiet caption-style title anchored to the bottom — image first */}
      <div className="absolute bottom-0 left-0 right-0 z-10 px-6 md:px-14 pb-24 md:pb-28" data-id="element-94">
        <motion.div initial="hidden" animate="visible" variants={fade} className="max-w-7xl mx-auto text-center" data-id="element-95">
          <h1 className="font-heading text-white font-light leading-[1.05] tracking-tight text-3xl sm:text-4xl md:text-5xl" data-id="element-96">
            35 Campanilla Corner Agoho
          </h1>
        </motion.div>
      </div>

      {/* Scroll Indicator — centered so it never overlaps the caption text */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-97">
        <div className="w-[1px] h-12 bg-white/20 overflow-hidden" data-id="element-98">
          <motion.div animate={{
          y: ['-100%', '100%']
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'linear'
        }} className="w-full h-full bg-white" data-id="element-99" />
        </div>
      </motion.div>
    </section>;
}